<template>
  <div>
    <h3 class="modal-title"> HTML </h3>

    <b-form-group :class="{'error-input' : $v.data_html.title.$error}">
      <label> HTML Title </label>
      <j-input
        v-model="$v.data_html.title.$model"
        :max-length="255"
        placeholder="HTML Title"/>
    </b-form-group>
    <quill-editor
      ref="myQuillEditor"
      v-model="data_html.html"
      :options="editorOption"
    />
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeHtml">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveHtml">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import he from 'he';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_html: {
      title: {
        required,
      },
      html: {},
    },
  },
  data() {
    return {
      data_html: {
        title: '',
        html: '',
      },
      config: {
        attribution: false,
        events: {
          initialized() {
            // console.log('initialized');
          },
        },
      },
      editorOption: {

      },
    };
  },
  computed: {

    generateDataHtml() {
      const data = {
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_html.title,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify({
          html: this.encodeHtmlEntities(this.data_html.html),
        }),
        type_platform: 1,
      };
      return data;
    },

    generateDataHtmlUpdate() {
      const data = {
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_html.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify({
          html: this.encodeHtmlEntities(this.data_html.html),
        }),
        type_platform: 1,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_html.title = this.dataEdit.name;
      this.data_html.html = he.decode(JSON.parse(this.dataEdit.info).html);
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent']),
    saveHtml() {
      this.$v.data_html.$touch();
      if (!this.$v.data_html.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataHtml,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataHtmlUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeHtml();
      }
    },

    closeHtml() {
      this.$emit('close-field');
      this.data_html.title = '';
      this.data_html.html = '';
      setTimeout(() => {
        this.$v.data_html.$reset();
      }, 1000);
    },

    encodeHtmlEntities(str) {
      return he.encode(str);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jHtmlSetup.vue